import React from 'react';
import PagarmeChallenge3dsModal from './PagarmeChallenge3dsModal';
import MalgaChallenge3dsModal from './MalgaChallenge3dsModal';
import { ExternalAuthenticationProviderType } from '@src/domains/payments';

type Challenge3dsModalRendererProps = {
  provider: ExternalAuthenticationProviderType;
};

const providers = {
  [ExternalAuthenticationProviderType.Pgmpi]: PagarmeChallenge3dsModal,
  [ExternalAuthenticationProviderType.Malga3ds2]: MalgaChallenge3dsModal,
  default: React.Fragment,
};

const Challenge3dsModalRenderer = (props: Challenge3dsModalRendererProps) => {
  const { provider } = props;

  const ProviderModal = providers[provider as keyof typeof providers] || providers.default;

  return <ProviderModal />;
};

export default Challenge3dsModalRenderer;
